import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { X, Check } from 'lucide-react';

export const LinkedInPostForm = ({ formData, setFormData, editing, onSubmit, onCancel }) => (
  <form onSubmit={onSubmit} className="mb-6 p-4 bg-gray-50 rounded-lg border" data-testid="linkedin-post-form">
    <div className="space-y-4">
      <div>
        <Label htmlFor="title">Title (Optional)</Label>
        <Input
          id="title"
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          placeholder="e.g., Latest Company Update"
          data-testid="linkedin-post-title"
        />
        <p className="text-xs text-gray-500 mt-1">A short description to identify this post in the CMS</p>
      </div>
      <div>
        <Label htmlFor="embedCode">LinkedIn Embed Code *</Label>
        <Textarea
          id="embedCode"
          value={formData.embedCode}
          onChange={(e) => setFormData({ ...formData, embedCode: e.target.value })}
          placeholder='<iframe src="https://www.linkedin.com/embed/feed/update/..." height="500" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>'
          rows={4}
          required
          data-testid="linkedin-post-embed"
        />
      </div>
      <div>
        <Label htmlFor="linkedinUrl">Original Post URL (Optional)</Label>
        <Input
          id="linkedinUrl"
          value={formData.linkedinUrl}
          onChange={(e) => setFormData({ ...formData, linkedinUrl: e.target.value })}
          placeholder="https://www.linkedin.com/posts/..."
          data-testid="linkedin-post-url"
        />
        <p className="text-xs text-gray-500 mt-1">If provided, visitors can click to view the post on LinkedIn</p>
      </div>
      <div className="flex gap-2">
        <Button type="submit" data-testid="save-linkedin-post-btn">
          <Check className="w-4 h-4 mr-2" />
          {editing ? 'Update Post' : 'Add Post'}
        </Button>
        <Button type="button" variant="outline" onClick={onCancel}>
          <X className="w-4 h-4 mr-2" /> Cancel
        </Button>
      </div>
    </div>
  </form>
);
